import React, { useEffect, useRef } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';
import { useTranslation } from 'react-i18next';

const About = () => {
	gsap.registerPlugin(ScrollTrigger);
	const ref = useRef(null);
	const { t } = useTranslation('translation', {
		keyPrefix: 'about',
	});

	useEffect(() => {
		let ctx = gsap.fromTo(
			ref.current,
			{
				opacity: 0,
				x: 200,
			},
			{
				opacity: 1,
				x: 0,
				duration: 1,
				scrollTrigger: {
					trigger: ref.current,
					start: 'top 20%',
					end: 'top',
					// scrub: true,
				},
			}
		);

		return () => ctx.revert();
	}, []);

	return (
		<section
			name='about'
			className='w-full h-screen bg-gradient-to-b from-gray-800
     to-black text-white'
		>
			<div
				ref={ref}
				className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'
			>
				<div className='pb-8'>
					<p className='text-4xl font-bold inline border-b-4 border-gray-500'>
						{t('title')}
					</p>
				</div>
				<p className='text-xl mt-20'>{t('firstP')}</p>

				<br />

				<p className='text-xl'>{t('secondP')}</p>
			</div>
		</section>
	);
};

export default About;
